import { AbstractPlugin } from '../plugin';

export class CalculateLoader extends AbstractPlugin {}
